import { Button, Form } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import { useNavigate } from "react-router-dom";

import { TableHelper } from "../../../util/TableHelper";

import type FixMeLater from "../../../shared/types/fixMeLater.type";

const DeadParkingTable = () => {
  const navigate = useNavigate();

  const dummydataStorage = [
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    },
    {
      sr_no: 1,
      user_Name: "c1",
      vehicle_Type: "SUV",
      location: "z111",
      deadSpot: "5"
    }
  ];

  const renderText = (text: FixMeLater) => {
    return <div className="wordWrapWordBreak">{TableHelper.getValue(text)}</div>;
  };
  const handleCancel = () => {
    navigate(-1);
  };

  const columnsStorage: ColumnsType<FixMeLater> = [
    {
      align: "right",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      width: "10%"
    },
    {
      align: "left",
      title: "Customer Name",
      dataIndex: "user_Name",
      key: "user_Name",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("user_Name")
      }
    },
    {
      align: "left",
      title: "Vehicle Type",
      dataIndex: "vehicle_Type",
      key: "vehicle_Type",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("vehicle_Type")
      }
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    }
  ];

  return (
    <>
      <Table className="gx-table-responsive" columns={columnsStorage} dataSource={dummydataStorage} bordered rowKey={(record) => record.sr_no} />

      <Form.Item className="form-button form-button mt0 mb0 mr17 ">
        <Button className="gx-mb-0 button-gradiant">Update</Button>
      </Form.Item>
      <Form.Item className="form-button form-button-pr mt0 mb0 ">
        <Button onClick={handleCancel} className="gx-mb-0 button-gradiant">
          Cancel
        </Button>
      </Form.Item>
    </>
  );
};
export default DeadParkingTable;
